

function toggleDropdownForStandardBraSize() {
  const dropdown = document.getElementById("standard-bra-size-dropdown-list");
  dropdown && dropdown.classList.toggle("show");
  toggleArrowDirection();
}

function selectStandardBraOption(element) {
  // Get selected value
  var selectedText = element.value;

  // Update the dropdown button text
  document.getElementById("standard-bra-size-selection").innerText = selectedText;

  // Hide dropdown after selection
  document.getElementById("standard-bra-size-dropdown-list").classList.remove("show");
  toggleArrowDirection();
}

function toggleArrowDirection() {
  const arrow = document.getElementById("select-arrow");
  if (arrow) {
    if (arrow.classList.contains("arrow-select-up")) {
      arrow.classList.remove("arrow-select-up");
    } else {
      arrow.classList.add("arrow-select-up");
    }
  }
}

function openOverlay() {
  document.querySelectorAll('.model-information-details').forEach(e => {
    if (!e.id.includes(chosenModelNumber + "")) {
      e.style.display = 'none'
    } else {
      e.style.display = 'block'
    }
  })

  document.getElementById("overlay").classList.add("show");
}

function closeOverlay() {
  document.getElementById("overlay").classList.remove("show");
}

function updateCartBraSizeFromLastValue() {
  return fetch('/cart.js').then(r=>r.json()).then(async c=>{let s=document.getElementById("standard-bra-size-selection"),l="",i=0,ps=[];if(s){l=s.innerText}else{c.items.forEach(item=>{if(item.properties&&item.properties["Standard Bra Size"]&&item.properties["Standard Bra Size"].trim()!=="")l=item.properties["Standard Bra Size"]})}while(i<c.items.length){let item=c.items[i];if(item.properties["Standard Bra Size"]&&item.properties["Standard Bra Size"]!==l){let p=item.properties||{};p["Standard Bra Size"]=l;let payload={id:item.key,quantity:item.quantity,properties:p};let res=await fetch('/cart/change.js',{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(payload)}).then(r=>r.json());ps.push(res)}i++}return Promise.all(ps)});
}
